import { render, staticRenderFns } from "./ReverseHelpDialog.vue?vue&type=template&id=38bdda84&scoped=true&"
import script from "./ReverseHelpDialog.vue?vue&type=script&lang=js&"
export * from "./ReverseHelpDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bdda84",
  null
  
)

export default component.exports